import { IoChatbubbleOutline } from "react-icons/io5";
import {useModal} from "../../hooks/useModal";

const UploadButton: React.FC<{
  showUploadMenuImageModal?: React.Dispatch<React.SetStateAction<boolean>>;
}> = () => {
  const { openModal } = useModal();
  return (
    <button
      className="w-10 h-10 flex items-center justify-center rounded-full bg-slate-200 hover:bg-slate-50"
      type="submit"
      onClick={() => openModal('uploadMenu')}
    >
      <IoChatbubbleOutline size={20} />
    </button>
  );
};

export default UploadButton;
